import { useEffect, useState } from 'react';

const breakpoint = 768;

export const useMobile = () => {

    const [isMobile, setMobile] = useState(determineIfMobile());

    useEffect(() => {
        if (process.env.REACT_APP_TO_BUILD !== 'website-server') {
            const onResize = () => setMobile(determineIfMobile());
            onResize();
            window.addEventListener('resize', onResize);
            return () => window.removeEventListener('resize', onResize);
        }
    }, []);

    return isMobile;
};

const determineIfMobile = () => {

    if (process.env.REACT_APP_TO_BUILD !== 'website-server') {
        return Math.min(window.innerWidth, window.innerHeight) < breakpoint
            && window.devicePixelRatio > 1;
    }

    return false;
};